import React from 'react'
import Styles from "./CompanyAdmin.module.css"
import Users from './UsersSide/Users'
import CompanyDashboard from './CompanyDashboard/CompanyDashboard'

const CompanyAdmin = () => {
  return (
    <div className={Styles.companyAdminContainer}>
        {/* <Users /> */}
        <CompanyDashboard/>
    </div>
  )
}

export default CompanyAdmin